export const getPlantCheesePackage = newProduct => {
  let newPlantCheesePackage = {
    UPC: newProduct.UPC,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    PlantCheeseAltType: newProduct.PlantCheeseAltType,
    Type: newProduct.Type,
    Form: newProduct.Form,
    Size: newProduct.Size,
  }

  if (newProduct.PlantCheeseAltType === 'Other') {
    newPlantCheesePackage.OtherPlantCheeseAltType =
      newProduct.OtherPlantCheeseAltType
  }

  if (newProduct.Type === 'Other') {
    newPlantCheesePackage.OtherType = newProduct.OtherType
  }

  return newPlantCheesePackage
}

export const updatePlantCheesePackage = newProduct => {
  let newPlantCheesePackage = {
    UPC: newProduct.UPC,
    Calcium: newProduct.Calcium,
    CalciumCertification: newProduct.CalciumCertification,
    Protein: newProduct.Protein,
    ProteinCertification: newProduct.ProteinCertification,
    PlantCheeseAltType: newProduct.PlantCheeseAltType,
    Type: newProduct.Type,
    Form: newProduct.Form,
    Size: newProduct.Size,
  }

  if (newProduct.PlantCheeseAltType === 'Other') {
    newPlantCheesePackage.OtherPlantCheeseAltType =
      newProduct.OtherPlantCheeseAltType
  }

  if (newProduct.Type === 'Other') {
    newPlantCheesePackage.OtherType = newProduct.OtherType
  }

  return newPlantCheesePackage
}
